import { Element } from "./Element";
import { Root } from "./Root";
import { Text } from "./Text";
import { Outline } from "./Outline";
import { Notification } from "./Notification";

export const Button = {
    Root: Root,
    Element: Element,
    Notification: Notification,
    Outline: Outline,
    Text: Text
}